import { useMutation } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';

export interface IPayload {
  name : string,
  amount : number,
  description : string
}

interface IProps {
  customerId: string;
  accountExternalId: string;
  payload:IPayload
}

export const useCreateNewServiceItem = () => useMutation(
  '',
  async ({
    customerId, accountExternalId, payload,
  }: IProps) => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/invoice/serviceItem`, { ...payload });
    return res.data;
  },
  { retry: 0 },
);
